import React, { Component } from 'react';

import { Field, reduxForm } from 'redux-form/immutable';
import { Col, Row } from 'react-flexbox-grid';
import { connect } from 'react-redux';
import CircularProgress from 'material-ui/CircularProgress';
import api from '../../../../utils/api';
import { fromJS } from 'immutable';

import { TextField } from 'redux-form-material-ui';

class DiscountEntryForm extends Component {
    render() {
        const { handleSubmit, isFetching } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                <Row>
                    <Col xs={10}>
                        <Field
                            onKeyPress={event => {
                                if (event.key === 'Enter') {
                                }
                            }}
                            onBlur={eventOrValue => {
                                const value = eventOrValue.target.value;
                                this.props.onSubmit(fromJS({ code: value }));
                            }}
                            floatingLabelText="Coupon-Code"
                            name="code"
                            component={TextField}
                            type="text"
                            errorText={
                                this.props.coupon.get('discount') !== null
                                    ? null
                                    : 'Dieser Coupon ist ungültig'
                            }
                            style={{ width: '100%' }}
                            label="Coupon-Code"
                        />
                    </Col>
                    <Col xs={2}>
                        {isFetching && (
                            <CircularProgress
                                style={{ marginTop: '20px' }}
                                size={40}
                                thickness={2}
                            />
                        )}
                    </Col>
                </Row>
            </form>
        );
    }
}

DiscountEntryForm = reduxForm({ form: 'voucher', enableReinitialize: true })(DiscountEntryForm);

class DiscountEntry extends Component {
    handleCouponCode = values => {
        values = values.toJS();
        this.props.submitCouponCode({
            code: values.code,
            planVariantId: this.props.planVariantId,
            planId: this.props.planId,
        });
    };

    render() {
        const { isFetching, handleSubmit } = this.props;

        return (
            <div>
                {!this.props.coupon.get('code') && (
                    <DiscountEntryForm
                        onSubmit={this.handleCouponCode}
                        coupon={this.props.coupon}
                        isFetching={this.props.isFetching}
                    />
                )}
                {this.props.coupon.get('code') && (
                    <Row style={{ marginTop: '20px', marginBottom: '20px' }}>
                        <Col xs={12}>
                            <div
                                style={{
                                    padding: '20px',
                                    backgroundColor: '#519a4d',
                                    color: 'white',
                                }}>
                                Coupon <strong>{this.props.coupon.get('code')}</strong> gewährt{' '}
                                <strong>
                                    pro Software-Abo{' '}
                                    {parseInt(this.props.coupon.get('discount') * 100)} %
                                </strong>{' '}
                                pro Monat Vergünstigung
                            </div>
                        </Col>
                    </Row>
                )}
            </div>
        );
    }
}

const mapActionCreators = dispatch => ({
    submitCouponCode: payload => dispatch(api.actions.coupons.submitCoupon(payload)),
});

const mapStateToProps = (state, props) => ({
    isFetching: state.coupons.getIn([props.planVariantId, 'isFetching'], false),
    coupon: state.coupons.getIn([props.planVariantId], fromJS({})),
});

export default connect(
    mapStateToProps,
    mapActionCreators
)(DiscountEntry);
